"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var Bonus = function () {
    var _a, _b, _c;
    var t = (0, next_intl_1.useTranslations)('phoneVerification');
    var data = (0, swr_hooks_1.useBonusesForPhoneVerification)().data;
    if (!((_a = data === null || data === void 0 ? void 0 : data.bonuses) === null || _a === void 0 ? void 0 : _a[0]))
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('bonusForPhoneVerification')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus }, ((_c = (_b = data === null || data === void 0 ? void 0 : data.bonuses) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.title) || '')));
};
exports.default = Bonus;
